// Hex equivalents of --color-theme-status-positive / -negative (light values:
// green/42, red/50). Canvas/TradingView can't read CSS vars, so the chart theme
// + trade-line overlays (position/order lines) use these constants.
// Light-mode values chosen as the single static value; revisit per-theme if
// dark-chart legibility needs it.
export const TRADE_GREEN_HEX = "#088f68";
export const TRADE_RED_HEX = "#e32633";

// Alpha-blended variants for order overlays (slightly subdued vs. positions).
export const TRADE_ORDER_GREEN = "rgba(8, 143, 104, 0.6)";
export const TRADE_ORDER_RED = "rgba(227, 38, 51, 0.6)";

// Liquidation price warning — denotives/orange so it stands apart from green/red.
export const TRADE_LIQUIDATION = "#ff9500";
